import * as Styled from './services-screen-group'

export { Styled }